import type { RuleGraphNodeKind } from "@intelligems/ig-types/dtos/agentic-logic/rule-graph";
import {
  RULE_GRAPH_HEADER_GAP,
  RULE_GRAPH_HEADER_HEIGHT,
  RULE_GRAPH_HEADER_WIDTH,
  RULE_GRAPH_NODE_HEIGHT,
  RULE_GRAPH_NODE_WIDTH,
  RULE_GRAPH_RESULT_WIDTH,
} from "./layout";

/** Dimensions shared by the visible card and its React Flow wrapper. */
export const ruleGraphFlowNodeSize = ({
  kind,
  isLaneHeader,
  hasResult,
}: {
  kind: RuleGraphNodeKind;
  isLaneHeader: boolean;
  hasResult: boolean;
}): { width: number; height: number } => {
  if (isLaneHeader && kind !== "fallback-terminal") {
    return { width: RULE_GRAPH_HEADER_WIDTH, height: RULE_GRAPH_HEADER_HEIGHT };
  }
  // As above: the terminal row keeps its full header-plus-card footprint.
  if (isLaneHeader && kind === "fallback-terminal") {
    return {
      width: RULE_GRAPH_HEADER_WIDTH,
      height:
        RULE_GRAPH_HEADER_HEIGHT +
        RULE_GRAPH_HEADER_GAP +
        RULE_GRAPH_NODE_HEIGHT,
    };
  }
  if (hasResult) {
    return { width: RULE_GRAPH_RESULT_WIDTH, height: RULE_GRAPH_NODE_HEIGHT };
  }
  return { width: RULE_GRAPH_NODE_WIDTH, height: RULE_GRAPH_NODE_HEIGHT };
};
